import cogoToast from "cogo-toast";
import { createSlice } from "@reduxjs/toolkit";

const compareSlice = createSlice({
  name: "compare",
  initialState: {
    compareItems: [],
  },
  reducers: {
    addToCompare(state, action) {
      const exists = state.compareItems.find(
        (item) => item.id === action.payload.id
      );

      if (exists) {
        cogoToast.info("Product already in compare", {
          position: "bottom-left",
        });
      } else {
        state.compareItems.push(action.payload);
        cogoToast.success("Added to compare", {
          position: "bottom-left",
        });
      }
    },

    deleteFromCompare(state, action) {
      state.compareItems = state.compareItems.filter(
        (item) => item.id !== action.payload
      );
      cogoToast.error("Removed from compare", {
        position: "bottom-left",
      });
    },
  },
});

export const { addToCompare, deleteFromCompare } = compareSlice.actions;
export default compareSlice.reducer;
